import { httpClient } from '@/lib/api';
import type { AuthUser } from '@/features/auth/types';
export interface AccountProfile extends AuthUser {
  phone?: string | null;
}
export interface AccountFormValues {
  firstName: string;
  lastName: string;
  phone: string;
}
export interface PasswordValues {
  currentPassword: string;
  newPassword: string;
  confirmation: string;
}
export const accountApi = {
  isConsultant: true,
  read: (): Promise<AccountProfile> => httpClient.get('/consultant-auth/account'),
  update: (input: AccountFormValues): Promise<AccountProfile> =>
    httpClient.patch('/consultant-auth/account', { phone: input.phone.trim() || null }),
  changePassword: (input: PasswordValues): Promise<void> =>
    httpClient.post('/consultant-auth/change-password', {
      currentPassword: input.currentPassword,
      newPassword: input.newPassword,
    }),
};
